import type { BrowserConfiguration } from '@bugsnag/browser-performance'
import BugsnagPerformance, { DefaultRoutingProvider } from '@bugsnag/browser-performance'
import type { Config } from '@bugsnag/js'
import Bugsnag from '@bugsnag/js'

import { logger } from '@/configs'

import { sharedBugsnagConfig, shouldInitializeBugsnag } from './index'

const dynamicRouteMap: [RegExp, string][] = [
  // Price routes - order matters: more specific first
  [/\/[^/]+\/price\/categories\/[^/]+$/i, '/[locale]/price/categories/[category]'],
  [/\/[^/]+\/price\/categories$/i, '/[locale]/price/categories'],
  [/\/[^/]+\/price\/[^/]+\/[^/]+$/i, '/[locale]/price/[slug]/[currency]'],
  [/\/[^/]+\/price\/[^/]+$/i, '/[locale]/price/[slug]'],
  [/\/[^/]+\/price$/i, '/[locale]/price'],
]

function resolveRoute(url: URL) {
  for (let i = 0; i < dynamicRouteMap.length; i++) {
    const [routeRegexp, routeName] = dynamicRouteMap[i]
    if (routeRegexp.test(url.pathname)) {
      return routeName
    }
  }
  return url.pathname
}

function getBugsnagClientConfig(): Config & BrowserConfiguration {
  return {
    ...sharedBugsnagConfig,
    appType: 'browser',
    routingProvider: new DefaultRoutingProvider(resolveRoute),
  }
}

/**
 * Initialize Bugsnag for client-side (browser)
 * Should be called from instrumentation-client.ts
 */
export function initBugsnagClient() {
  if (!shouldInitializeBugsnag()) return

  const config = getBugsnagClientConfig()

  Bugsnag.start(config)

  BugsnagPerformance.start(config)

  if (Bugsnag.isStarted()) {
    logger.info('Bugsnag client initialized successfully')
  } else {
    logger.error('Failed to initialize Bugsnag client')
  }
}
